<div class="page">
    <div class="container">
        <div class="top_area">
            <div class="item row row_ai_center">
                <app-filter-btn></app-filter-btn>
                <button (click)="openModal('createCustomerPopup')" type="button" class="btn dark_btn row fz_s fw_500">Создать клиента <span
                        class="material-symbols-outlined fz_m">
                        add</span></button>
            </div>
            <app-filter (applyFilter)="onFilterApply($event)" (resetFilter)="onFilterReset()" [filterData]="filter"
                *ngIf="activeFilter">
                <app-filter-customer [customerFilter]="filter"></app-filter-customer>
            </app-filter>
        </div>
        <app-table [path]="'customers'" [dataMissing]="dataMissing" [data]="customers" [columns]="columns" [pagination]="{
                currentPage: currentPage,
                pageSize: pageSize,
                totalItems: totalItems
            }" (pageChange)="onPageChange($event)"><app-skeleton *ngIf="isLoading" height="40" margin="15"
                count="12"></app-skeleton></app-table>
    </div>
</div>
<app-modal-create-customer *ngIf="(modalService.modalState$ | async) == 'createCustomerPopup'" (changeState)="getCustomers()"></app-modal-create-customer>
<app-toastr></app-toastr>